import React from 'react';
import { Link } from 'react-router-dom';
import AdminSignOutButton from './AdminSignOutButton';
import './AdminPage.css';

const AdminPage = ({ user }) => {
    return (
        <section className="admin-page">
            <div className="admin-shell">
                <header className="admin-header">
                    <div>
                        <p className="admin-kicker">Private Admin</p>
                        <h1>Admin Dashboard</h1>
                        <p>
                            Signed in as <strong>{user?.email || 'authenticated user'}</strong>.
                            Use this area for private site management.
                        </p>
                    </div>
                    <div className="admin-header-actions">
                        <AdminSignOutButton />
                    </div>
                </header>

                <div className="admin-dashboard-grid">
                    <Link className="admin-dashboard-card admin-dashboard-card-active" to="/admin/messages">
                        <span>Inbox</span>
                        <h2>Messages</h2>
                        <p>Read and manage contact form submissions.</p>
                    </Link>

                    <article className="admin-dashboard-card admin-dashboard-card-disabled">
                        <span>Future</span>
                        <h2>Resources Manager</h2>
                        <p>Placeholder for managing whitepapers, PDFs, and templates later.</p>
                    </article>

                    <article className="admin-dashboard-card admin-dashboard-card-disabled">
                        <span>Future</span>
                        <h2>Site Content</h2>
                        <p>Placeholder for future content and publishing workflows.</p>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default AdminPage;
